import React from 'react';
import CurrentDefenses from './CurrentDefenses';
import ExistingControl from './ExistingControl';
import Effects from './Effects';
import AssociatedRisks from './AssociatedRisks';
import Accordion from '../../Accordion';

const identifications = [
  { name: 'Current Defenses', component: CurrentDefenses },
  { name: 'Existing Controls', component: ExistingControl },
  { name: 'Effects', component: Effects },
  { name: 'Associated Risks', component: AssociatedRisks },
];
const Analysis = () => (
  <div className="w-full mx-auto">
    {identifications.map((identification) => (
      <div key={identification.name} className="rounded-md shadow-md mb-10">
        <Accordion
          title={identification.name}
          content={identification.component}
        />
      </div>
    ))}
  </div>
);
export default Analysis;
